"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Takes a function (promiseCreator) that returns a Promise and returns a new
// version of the function.
// The new function will work the same as the original promiseCreator function
// except if it is called again before a previously returned Promise has yet to
// resolve it returns that same Promise again.

// Used in the Auth Middleware to stop multiple "refresh token" requests
// happening at the same time.
// The arguments are *NOT* checked to be the same while memoized as it is not
// needed for this use case.
var memoizeWhilePending = exports.memoizeWhilePending = function memoizeWhilePending(promiseCreator) {
  var cachedPromise = null;
  var clearCachedPromise = function clearCachedPromise() {
    return cachedPromise = null;
  };
  var memoizeFn = function memoizeFn() {
    // No promise in flight, create a new one.
    if (cachedPromise === null) {
      cachedPromise = promiseCreator.apply(undefined, arguments);
      // Clear the cachedPromise when it settles.
      cachedPromise.finally && cachedPromise.finally(clearCachedPromise);
    }
    return cachedPromise;
  };
  return memoizeFn;
};